module.exports = __webpack_public_path__ + "img/744.34d006db.jpg";